var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('actions-editor', {
    attrs: {
      "dashboard-id": _vm.dashboardId,
      "custom-parameters": _vm.customParameters,
      "data": _vm.data
    },
    model: {
      value: _vm.mapActions,
      callback: function ($$v) {
        _vm.mapActions = $$v;
      },
      expression: "mapActions"
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };